import { Link } from "react-router-dom";

import { kanziSections } from "../../../../content/kanziSections";
import Eyebrow from "../../Eyebrow";
import BrainViz from "../../BrainViz";

const Hero = ({ heroRef }) => (
  <section ref={heroRef} className="hero-section">
    <div className="hero-section__glow" />
    <BrainViz />

    <div className="hero-section__inner">
      <Eyebrow>{kanziSections.hero.eyebrow}</Eyebrow>

      <h1 className="kanzi-hero__h1">
        <span className="kanzi-hero__accent">{kanziSections.hero.titleAccent}</span>
        <br />
        <span className="kanzi-hero__main">{kanziSections.hero.titleMain}</span>
      </h1>

      <div className="glow-line hero-section__divider" />

      <div className="hero-section__content">
        <p className="section-intro">{kanziSections.hero.description}</p>

        <div className="hero-section__actions">
          <Link
            to={kanziSections.hero.primaryCta.href}
            className="button button-primary"
            title="Schedule a Kanzi discovery call"
          >
            {kanziSections.hero.primaryCta.label}
          </Link>
          <Link
            to={kanziSections.hero.secondaryCta.href}
            className="button button-secondary"
            title="Learn how Kanzi works"
          >
            <span style={{ display: "inline-block" }}>
              {kanziSections.hero.secondaryCta.label} &rarr;
            </span>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
